import { FinancialDetails } from 'cpfr-common';
import { useAnalyticsActionTracker } from '@cp-shared-19/frontend-ui';
import { Hr } from '@vwfs-bronson/bronson-react';
import { changePaymentDayPath } from 'components/navigation/paths';
import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { EditView } from './edit-view/EditView';
import { EditStatus } from './enums';
import { NonEditView } from './non-edit-view/NonEditView';
import { useDispatch } from 'react-redux';
import { paymentDayStatusTagFetchStateActions } from './non-edit-view/usePaymentDayStatusTagSlice';
import { scrollToElement } from '../../../../../utils';

type CollectionDateSectionProps = {
    details?: FinancialDetails;
    isActive?: boolean;
    contractId: string;
    isContactInformationChangePending: boolean;
    isSMECustomer?: boolean;
    isVDLContract?: boolean;
    setShowSuccessNotification: (val: boolean) => void;
    customerType?: string;
};

export const CollectionDateSection: React.FC<CollectionDateSectionProps> = ({
    details,
    isActive,
    contractId,
    isContactInformationChangePending,
    isSMECustomer = false,
    isVDLContract = false,
    setShowSuccessNotification,
}) => {
    const history = useHistory();
    const location = useLocation<{ state_date?: EditStatus }>();
    const { state_date } = location.state || { state_date: EditStatus.NOT_PERFORMED };
    const { path } = useRouteMatch();
    const [editStatus, setEditStatus] = useState(state_date);
    const { onAction } = useAnalyticsActionTracker('financialDetailsEditDueDateSection');
    const dispatch = useDispatch();

    useEffect(() => {
        if (details && isActive && location.pathname === changePaymentDayPath(contractId)) {
            setTimeout(() => {
                scrollToElement(`collection-date-section-edit-view-${contractId}`, 1000);
            }, 100);
        }
    }, [location.pathname, contractId, details, isActive]);

    if (!details || !isActive) {
        return null;
    }

    const startEditing = (): void => {
        onAction();
        history.replace(changePaymentDayPath(contractId));
        setTimeout(() => {
            scrollToElement(`collection-date-section-edit-view-${contractId}`, 1000);
        }, 100);
        setEditStatus(EditStatus.NOT_PERFORMED);
    };

    const finishEditing = (editStatus: EditStatus): void => {
        setEditStatus(editStatus);
        dispatch(paymentDayStatusTagFetchStateActions.setStatusTag(true));
        history.replace(path, { state_date: editStatus });
        if (editStatus === EditStatus.SUCCESS) {
            setShowSuccessNotification(true);
        }
        setTimeout(() => {
            scrollToElement(`collection-date-section-view-${contractId}`, 1000);
        }, 100);
    };

    return (
        <>
            <Hr className={'u-mb-none'} />
            <Switch>
                <Route exact path={changePaymentDayPath()}>
                    <EditView details={details} contractId={contractId} finishEditing={finishEditing}></EditView>
                </Route>
                <Route path={path}>
                    <NonEditView
                        editButtonDisabled={
                            isContactInformationChangePending ||
                            isSMECustomer ||
                            isVDLContract ||
                            editStatus === 'SUCCESS'
                        }
                        details={details}
                        isActive={isActive}
                        startEditing={startEditing}
                        editStatus={editStatus || EditStatus.NOT_PERFORMED}
                        isSMECustomer={isSMECustomer}
                        isVDLContract={isVDLContract}
                    />
                </Route>
            </Switch>
        </>
    );
};
